import { Group } from "@mantine/core"
import type { Prisma } from "@tfg/db"

import { FilterLine } from "~/pages/Brand/OrganizationSettings/ProductPages/DisplaySettingsCrud/FiltersForm/FiltersLine.tsx"
import { SplitButton } from "~/pages/Brand/OrganizationSettings/ProductPages/DisplaySettingsCrud/FiltersForm/SplitButton.tsx"

interface Props {
  filters: Prisma.JsonObject
  setFilters: (filters: Prisma.JsonObject) => void
  filterKey: string
  value: Prisma.JsonObject
}

export const FiltersSimpleSection = ({
  filters,
  setFilters,
  filterKey,
  value,
}: Props) => (
  <Group gap={3} wrap="nowrap">
    <SplitButton
      onClick={() => {
        filters = { AND: [filters] }
        setFilters(filters)
      }}
    />
    <FilterLine
      filter={{ [filterKey]: Object(value) }}
      setFilter={(input) => {
        delete filters[filterKey]
        filters = { ...filters, ...input }
        setFilters(filters)
      }}
      removeFilter={() => {
        delete filters[filterKey]
        setFilters(filters)
      }}
    />
  </Group>
)
